module.exports = {"370505001":"垦利街道","370505002":"兴隆街道","370505101":"胜坨镇","370505102":"郝家镇","370505104":"永安镇","370505105":"黄河口镇","370505106":"董集镇","370505400":"开发区类似乡级单位","370505402":"红光类似乡级单位","370505403":"垦东类似乡级单位","370505404":"东营市现代畜牧业示范区类似乡级单位"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370505.json
// module id = 1392
// module chunks = 0